import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-pictureInput-control-label-view, [app-pictureInput-control-label-view]',
  templateUrl: './pictureInput-control-label-view.component.html',
  styleUrls: ['./pictureInput-control-label-view.component.scss']
})
export class PictureInputControlLabelViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

}
